import { TPPClaimsState } from "@/models/store/TPPClaimsState";

export const propertyDamageMutations = {
  setClaimDescribedItems: (state: TPPClaimsState, describedItems: string) => {
    state.selectedTPPClaim!.damaged_items = describedItems;
  },
  setClaimDamageDescription: (state: TPPClaimsState, damageDescription: string) => {
    state.selectedTPPClaim!.damage_description = damageDescription;
  },
  setClaimEstimatedDamage: (state: TPPClaimsState, estimatedDamage: number) => {
    state.selectedTPPClaim!.damage_estimate = estimatedDamage;
  }
};
